function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0-5.625a3.75,3.75,0,0,0,3.75-3.75A3.75,3.75,0,0,0,0-13.125a3.75,3.75,0,0,0-3.75,3.75A3.75,3.75,0,0,0,0-5.625Zm0-6.562A2.817,2.817,0,0,1,2.812-9.375,2.817,2.817,0,0,1,0-6.562,2.817,2.817,0,0,1-2.813-9.375,2.817,2.817,0,0,1,0-12.187ZM2.692-4.213,1.529-.176.536-3.155l.732-.732a.469.469,0,0,0-.331-.8H-.938a.468.468,0,0,0-.331.8l.732.732L-1.529-.176-2.692-4.21A3.93,3.93,0,0,0-6.562-.281v.75A1.407,1.407,0,0,0-5.156,1.875H5.156A1.407,1.407,0,0,0,6.562.469v-.75A3.935,3.935,0,0,0,2.692-4.213ZM-5.156.937A.47.47,0,0,1-5.625.469v-.75a3.011,3.011,0,0,1,2.253-2.9L-2.183.937Zm4.245,0L0-1.8.911.937ZM5.625.469a.47.47,0,0,1-.469.469H2.183L3.369-3.179a3.011,3.011,0,0,1,2.253,2.9v.75Z",
  transform: "translate(6.563 13.125)",
  opacity: 0.871
});

var SvgIconSide08 = function SvgIconSide08(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.125,
    height: 15,
    viewBox: "0 0 13.125 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide08, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-08.c2c7c899.svg";
export { ForwardRef as ReactComponent };